import React from "react";
import CalendlyButton from "./CalendlyButton";

const Consultation = () => {
  return (
    <div className="div" id="book">
      <div className="inner-div consultation">
        <CalendlyButton />
      </div>
    </div>
  );
};

export default Consultation;
